import _ from "lodash"
import { useCallback, useEffect, useRef } from "react"

export const useRefreshControl = (callback: (props?: unknown) => unknown) => {
  const lastRefreshTime = useRef(Date.now())
  const listener = useCallback(
    _.debounce(() => {
      if (!document.hidden && Date.now() - lastRefreshTime.current > 3600_000) {
        lastRefreshTime.current = Date.now()
        callback()
      }
    }, 200),
    [],
  )

  useEffect(() => {
    document.addEventListener("visibilitychange", listener)
    document.addEventListener("webOSRelaunch", listener)
    return () => {
      document.removeEventListener("visibilitychange", listener)
      document.removeEventListener("webOSRelaunch", listener)
    }
  })
}
